import { createSingleAction } from 'store/utils';

export const SET_CONTROLLING_ORG_FILTER = 'settings/controllingOrgs/SET_CONTROLLING_ORG_FILTER';
export const setControllingOrgFilter = createSingleAction<string, typeof SET_CONTROLLING_ORG_FILTER>(
    SET_CONTROLLING_ORG_FILTER,
);
